<template>
    <div>
      <v-main>
        <v-dialog
          v-model="dialogAddpoint"
          persistent
          max-width="600px"
        >
          <v-card class="pa-5 pt-7">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" style="padding: 0px 0px">
                    <v-select
                      v-model="formAdd.productExchangeRateId"
                      label="สินค้า/บริการ"
                      :items="ProductExchangeRate"
                      solo
                      required
                    ></v-select>
                  </v-col>
                  <v-col cols="12" style="padding: 0px 0px">
                    <v-text-field
                      v-model="formAdd.amount"
                      label="จำนวนคะแนน"
                      type="number"
                      :min="0"
                      solo
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" style="padding: 0px 0px">
                    <v-select
                      v-model="formAdd.masBranchID"
                      :items="dataBranch"
                      label="สาขา"
                      solo
                      :menu-props="{ bottom: true, offsetY: true }"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small class="pl-5">*กรุณากรอกข้อมูล</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="callApiAddpoint"
                :loading="loading"
                :disabled="formAdd.masBranchID === '' || formAdd.productExchangeRateId === '' || formAdd.amount === ''"
              >
                เพิ่มคะแนน
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                @click="dialogAddpoint = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div v-if="resCol === '12'" >
            <v-container>
              <StreamBarcodeReader v-if="openCamera"
                  @decode="(a, b, c) => onDecode(a, b, c)"
                ></StreamBarcodeReader>
                <v-card style="height:220px" v-if="memberData">
                    <v-list-item three-line style="background-color: !important;">
                      <v-list-item-content>
                          <div class="text-overline mb-4 text-h5 " style="color: white !important">
                            คุณ {{ memberData.name }}
                          </div>
                          <v-list-item-title class="text-h7" style="color: white !important">
                            <div class="mb-1" style="display:flex">คะแนนปัจจุบัน: <div class="ml-2">{{ formatNumber(memberData.currentPoint) }} คะแนน</div></div>
                            <div class="mb-1" style="display:flex">คะแนนสะสม: <div class="ml-2">{{ formatNumber(memberData.collectPoint) }} คะแนน</div></div>
                            <div class="mb-1" style="display:flex">ระดับสมาชิก: <div class="ml-2">{{ formatNumber(memberData.LevelName) }}</div></div>
                            <div style="display:flex">เบอร์โทรศัพท์: <div class="ml-2">{{ this.formatPhoneNumber(memberData.tel) }}</div></div>
                          </v-list-item-title>
                      </v-list-item-content>
                      <v-avatar
                          size="80"
                          color="grey"
                      >
                      <img
                          :src="memberData.picture"
                          alt="John"
                        >
                      </v-avatar>
                    </v-list-item>

                    <v-card-actions style="justify-content: center;">
                    <v-btn @click="addPoint"
                    rounded
                    color="green"
                    dark
                    small
                    >
                        <v-icon>mdi-plus-circle-multiple</v-icon>เพิ่มคะแนน
                    </v-btn>
                    <!-- <v-btn @click="verifyMember"
                    rounded
                    color="primary"
                    dark
                    small
                    >
                      <v-icon class="mr-1">mdi-card-account-mail</v-icon> ยืนยันตัวตน
                    </v-btn> -->
                    <v-btn @click="clearData"
                    rounded
                    color="primary"
                    dark
                    small
                    >
                      <v-icon>mdi-account-search</v-icon> ค้นหาใหม่
                    </v-btn>
                    </v-card-actions>
                </v-card>
                <div style="display:flex;margin-bottom:10px;margin-top:10px;" v-if="memberData">
                    <!-- <v-chip-group
                      color="primary"
                    > -->
                    <v-chip-group
                      mandatory
                      active-class="primary--text"
                    >
                      <v-chip
                        v-for="tag in tags"
                        @click="changeTag(tag)"
                        :key="tag"
                      >
                        {{ tag }}
                      </v-chip>
                    </v-chip-group>
                </div>
                <v-card style="min-height:450px" v-if="memberData" class="pa-5">
                  <div v-if="tagSelect === 'สิทธิประโยชน์'">
                    <p v-if="memberData">ระดับบัตรสมาชิก {{ memberData.LevelName }}</p>
                    <v-row class="mt-2" v-if="memberData">
                        <v-col><nl2br tag="p"  v-if="memberData.priviledge" :text="memberData.priviledge"/></v-col>
                    </v-row>
                    <v-row class="mt-2" v-if="!memberData">
                        <v-col><nl2br tag="p" :text="'ไม่มีข้อมูล'"/></v-col>
                    </v-row>
                  </div>
                  <div v-if="tagSelect === 'ประวัติการได้คะแนน'">
                    ประวัติการได้คะแนน
                    <v-data-table
                      dense
                      :headers="headers"
                      :items="allDataTransactionGetpoint"
                      item-key="name"
                      class="elevation-1 mt-3"
                    ></v-data-table>
                  </div>
                </v-card>
                <div v-if="!memberData" :style="resCol === '6' ? 'width: 400px' : ''">
                  <v-text-field
                    v-model="text"
                    label="รหัสสมาชิก"
                    outlined
                    class="mt-8 px-0"
                    v-mask="'##-######-##'"
                    append-icon="mdi-barcode-scan"
                    @click:append="toggleMarker"
                    style="padding-left: 0px !important; padding-right: 0px !important"
                  >
                  </v-text-field>
                  <v-btn block style="color: white !important; padding: 0 16px 0 16px;background-color:#1b437c !important" @click="findMember">
                    ค้นหา
                  </v-btn>
                  <div class="mt-5" v-if="!memberData">
                    *** สามารถกรอกรหัสสมาชิกหรือสแกน บาร์โค้ด โดยการกดที่ icon สแกน ข้างช่องกรอกข้อมูล
                  </div>
                </div>
            </v-container>
        </div>
        <div style="" v-if="resCol === '6'">
          <v-container style="display: flex">
            <div style="width: 470px">
              <StreamBarcodeReader v-if="openCamera"
                  @decode="(a, b, c) => onDecode(a, b, c)"
              ></StreamBarcodeReader>
              <div>
                <v-text-field
                  v-model="text"
                  label="รหัสสมาชิก"
                  outlined
                  class="mt-8 px-0"
                  v-mask="'##-######-##'"
                  append-icon="mdi-barcode-scan"
                  @click:append="toggleMarker"
                  style="padding-left: 0px !important; padding-right: 0px !important"
                >
                </v-text-field>
                <v-btn block style="color: white !important; padding: 0 16px 0 16px;background-color:#1b437c !important" @click="findMember">
                  ค้นหา
                </v-btn>
                <div class="mt-5" >
                  *** สามารถกรอกรหัสสมาชิกหรือสแกน บาร์โค้ด โดยการกดที่ icon สแกน ข้างช่องกรอกข้อมูล
                </div>
              </div>
            </div>
            <v-divider class="ml-6" vertical/>
            <div class="ml-8">
              ข้อมูลลูกค้า
              <v-card style="display:flex !important;width: 550px;flex-direction: row;" class="pa-8 mt-3">
                <v-avatar size="100">
                  <img
                    :src="memberData? memberData.picture  : 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'"
                    alt="John"
                  >
                </v-avatar>
                <div style="margin-left: 40px">
                  <div class="mb-1" style="display:flex;font-weight: 100 !important;">ชื่อ: <div class="ml-2">{{ memberData ?  memberData.name : '-' }}</div></div>
                  <div class="mb-1" style="display:flex;font-weight: 100 !important;">เบอร์โทรศัพท์: <div class="ml-2">{{ memberData ?  this.formatPhoneNumber(memberData.tel) : '-' }}</div></div>
                  <div class="mb-1" style="display:flex;font-weight: 100 !important;">คะแนนปัจจุบัน: <div class="ml-2" style="display: flex;"><v-img width="20" height="20" class="mr-2" v-if="memberData" :src="require('@/assets/coin.png')"/>{{ memberData ? formatNumber(memberData.currentPoint) + ' คะแนน' : '-' }}</div></div>
                  <div class="mb-1" style="display:flex;font-weight: 100 !important;">คะแนนสะสม: <div class="ml-2" style="display: flex;"><v-img width="20" height="20" class="mr-2" v-if="memberData" :src="require('@/assets/coin.png')"/>{{ memberData ?  formatNumber(memberData.collectPoint) + ' คะแนน' : '-' }}</div></div>
                  <div class="mb-1" style="display:flex;font-weight: 100 !important;">ระดับสมาชิก: <div class="ml-2" style="display: flex;"><v-img width="45" class="mr-2" v-if="memberData" :src="memberData.pictureUrl"/>{{ memberData ?  memberData.LevelName : '-' }}</div></div>
                </div>
              </v-card>
              <div style="display:flex;margin-bottom:10px;margin-top:10px;">
                    <v-chip-group
                      mandatory
                      active-class="primary--text"
                    >
                      <v-chip
                        v-for="tag in tags"
                        @click="changeTag(tag)"
                        :key="tag"
                      >
                        {{ tag }}
                      </v-chip>
                    </v-chip-group>
              </div>
              <v-card style="padding: 20px">
                <div v-if="tagSelect === 'สิทธิประโยชน์'">
                  <p v-if="memberData">ระดับบัตรสมาชิก {{ memberData.LevelName }}</p>
                  <v-row class="mt-2" v-if="memberData">
                      <v-col><nl2br tag="p"  v-if="memberData.priviledge" :text="memberData.priviledge"/></v-col>
                  </v-row>
                  <v-row class="mt-2" v-if="!memberData">
                      <v-col><nl2br tag="p" :text="'ไม่มีข้อมูล'"/></v-col>
                  </v-row>
                </div>
                <div v-if="tagSelect === 'ประวัติการได้คะแนน'">
                  ประวัติการได้คะแนน
                  <v-data-table
                    dense
                    :headers="headers"
                    :items="allDataTransactionGetpoint"
                    item-key="name"
                    class="elevation-1 mt-3"
                  >
                      <template v-slot:[`item.point`]="{ item }">
                        {{ formatNumber(item.point) }}
                      </template>
                      <template v-slot:[`item.getDate`]="{ item }">
                        {{ thaiFormattedDate(item.getDate) }}
                      </template>
                  </v-data-table>
                </div>
              </v-card>
              <v-btn
                class="mt-5 mr-2"
                style="background-color:#35ca35 !important;color: white !important"
                @click="addPoint"
                :disabled="!memberData"
              >
                <v-icon>mdi-plus-circle-multiple</v-icon>เพิ่มคะแนน
              </v-btn>
              <!-- <v-btn
                class="mt-5 mr-2"
                style="color: white !important;background-color:#1b437c !important"
                @click="verifyMember"
              >
              <v-icon class="mr-2">mdi-card-account-mail</v-icon>ยืนยันตัวตน
              </v-btn> -->
            </div>
          </v-container>
        </div>
      </v-main>
    </div>
  </template>
<script>
import axios from 'axios' // api
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { StreamBarcodeReader } from 'vue-barcode-reader'
export default {
  components: {
    StreamBarcodeReader,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      previllage: true,
      memberData: null,
      text: null,
      openCamera: false,
      dialogAddpoint: false,
      dataBranch: null,
      ProductExchangeRate: null,
      formAdd: {
        productExchangeRateId: '',
        amount: '',
        tel: '',
        masBranchID: '',
        refId: '',
        point: '',
        token: '',
        status: 'waiting',
        statusMemberCard: 'collect',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        qrCodeURL: '',
        CREATE_DATE: ''
      },
      loading: false,
      tags: [
        'สิทธิประโยชน์',
        'ประวัติการได้คะแนน'
      ],
      tagSelect: 'สิทธิประโยชน์',
      qrCodePoint: null,
      specailPoint: null,
      activiPoint: null,
      allDataTransactionGetpoint: [],
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: 1
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: 1
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: 7
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: 8
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: 16
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: 0
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: 2
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: 45
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: 22
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: 6
        }
      ],
      headers: [
        {
          text: 'หัวข้อ',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'ชื่อ', value: 'nameOfType' },
        { text: 'คะแนน', value: 'point' },
        { text: 'วันที่ได้รับ', value: 'getDate' }
      ]
    //   session: this.$session.getAll(),
    //   path: '/AddCoin/', // Path Model
    //   returnLink: '/Master/AddCoin',
    //   valid: true,
    //   dialogReCheck: false,
    //   dialogImport: false,
    //   profile: false,
    //   statusnotifyAddcoin: null,
    //   formAdd: {
    //     productExchangeRateId: '',
    //     amount: '',
    //     tel: '',
    //     masBranchID: '',
    //     refId: '',
    //     point: '',
    //     token: '',
    //     status: 'waiting',
    //     statusMemberCard: 'collect',
    //     CREATE_USER: '',
    //     LAST_USER: '',
    //     shopId: '',
    //     qrCodeURL: '',
    //     CREATE_DATE: ''
    //   },
    //   formProfile: {
    //     picture: '',
    //     name: '',
    //     tel: '',
    //     point: '',
    //     totalpoint: '',
    //     LevelName: '',
    //     nameCustomer: '',
    //     memberId: '',
    //     points: ''
    //   },
    //   rules: {
    //     required: (value) => !!value || 'กรุณากรอก.'
    //   },
    //   ProductExchangeRate: [],
    //   dataBranch: [],
    //   confirmBtn: true,
    //   cancelBtn: false,
    //   them: '',
    //   loadingAdd: false,
    //   loading: false,
    //   dataItemImport: [],
    //   columnsImport: [
    //     { text: 'เบอร์โทรศัพท์', value: 'tel' },
    //     { text: 'Status', value: 'status', sortable: false }
    //   ],
    //   dataIm: [],
    //   importPoint: {
    //     productExchangeRateId: '',
    //     amount: '',
    //     masBranchID: ''
    //   },
    //   dataMember: null,
    //   file: null,
    //   data: {}
    }
  },

  async mounted () {
    await this.getProductExchangeRate()
    await this.getDataBranch()
    // var obj = document.getElementById('test')
    // obj.scrollTop = 2000
    // window.scroll({
    //   top: 100,
    //   left: 100,
    //   behavior: 'smooth'
    // })
    // var objDiv = document.getElementById('your_div')
    // objDiv.scrollTo(0, 1500)
    // console.log('dddd', objDiv)
    // this.getDataMember()
    // await this.getThem()
    // await this.hexToRgbA(this.them.slice(0, -2))
    // // this.HEXToVBColor(this.them) this.them.slice(0, -2)
    // await this.getProductExchangeRate()
    // await this.getDataBranch()
    // this.checkNotifyStatusAddcoin()
    // this.sessionCheck()
    // console.log(
    //   'this.$session.getAll()',
    //   this.$session.getAll().data.notify_status_addcoin
    // )
  },
  methods: {
    toggleMarker () {
      console.log('ddddd')
      this.openCamera = !this.openCamera
    },
    onDecode (a) {
      console.log(a)
      if (a) {
        this.text = a
        this.openCamera = false
      }
    },
    async verifyMember () {
      console.log('verifyMember')
      window.scrollTo(0, 500)
      // try {
      //   var obj = document.getElementById('test')
      //   obj.scrollTop = 2000
      // } catch (error) {
      //   console.log(error)
      // }
    },
    async findMember () {
      this.qrCodePoint = null
      this.specailPoint = null
      this.activiPoint = null
      this.allDataTransactionGetpoint = []
      if (!this.text) {
        this.$swal('ผิดพลาด', 'กรุณากรอกรหัสสมาชิก', 'error')
      } else {
        await this.getMemberData()
        if (this.memberData) {
          await this.getMemberTransactionQrcode()
          await this.getSpecailPoint()
          await this.getPointActivity()
          await this.insertSearchTransactions()
          console.log('qrCodePoint', this.qrCodePoint)
          console.log('specailPoint', this.specailPoint)
          console.log('activiPoint', this.activiPoint)
          if (this.qrCodePoint) {
            this.qrCodePoint.forEach((item) => {
              console.log()
              this.allDataTransactionGetpoint.push(
                {
                  'name': 'สินค้า/บริการ',
                  'nameOfType': item.productExchangeRateName,
                  'point': item.point,
                  'getDate': item.LAST_DATE
                }
              )
            })
          }
          if (this.specailPoint) {
            this.specailPoint.forEach((item) => {
              console.log()
              this.allDataTransactionGetpoint.push(
                {
                  'name': 'คะแนนพิเศษ',
                  'nameOfType': item.type_specialPoint,
                  'point': item.point,
                  'getDate': item.CREATE_DATE
                }
              )
            })
          }
          if (this.activiPoint) {
            this.specailPoint.forEach((item) => {
              console.log()
              this.allDataTransactionGetpoint.push(
                {
                  'name': 'กิจกรรม',
                  'nameOfType': item.title,
                  'point': item.poiint,
                  'getDate': item.CREATE_DATE
                }
              )
            })
          }
          console.log('allDataTransactionGetpoint', this.allDataTransactionGetpoint)
        }
      }
    },
    async getMemberData () {
      try {
        await axios
          .get(
            this.DNS_IP +
              '/member/get?shopId=' +
              this.$session.getAll().data.shopId +
              '&barcodeNum=' +
              this.text
          )
          .then((result) => {
            if (result.data.status === false) {
              this.$swal(
                'ไม่พบบัญชีผู้ใช้',
                'กรุณาตรวจสอบรหัสสมาชิก',
                'error'
              )
              this.memberData = null
              // this.confirmBtn = true
            } else {
              this.memberData = result.data[0]
              console.log('testt', result.data)
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    async insertSearchTransactions () {
      try {
        let data = {
          'memberId': this.memberData.memberId,
          'shopId': this.memberData.shopId,
          'CREATE_USER': this.$session.getAll().data.userEmail
        }
        await axios
          .post(
            this.DNS_IP +
              '/LogSearchMember/add', data
          )
          .then((result) => {
            if (result.data.status === false) {
            // this.$swal(
            //   'ไม่พบบัญชีผู้ใช้',
            //   'กรุณาตรวจสอบหมายเลขโทรศัพท์',
            //   'error'
            // )
            // this.confirmBtn = true
            } else {
              // this.qrCodePoint = result.data
              // console.log('test2', result.data)
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    async getMemberTransactionQrcode () {
      try {
        await axios
          .get(
            this.DNS_IP +
              '/qrcode/get?status=used&shopId=' +
              this.$session.getAll().data.shopId +
              '&memberId=' +
              this.memberData.memberId
          )
          .then((result) => {
            if (result.data.status === false) {
            // this.$swal(
            //   'ไม่พบบัญชีผู้ใช้',
            //   'กรุณาตรวจสอบหมายเลขโทรศัพท์',
            //   'error'
            // )
            // this.confirmBtn = true
            } else {
              this.qrCodePoint = result.data
              // console.log('test2', result.data)
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    async getSpecailPoint () {
      try {
        await axios
          .get(
            this.DNS_IP +
              '/Log_SpecialPoint/get?type_specialPoint=welcome_point&shopId=' +
              this.$session.getAll().data.shopId +
              '&memberId=' +
              this.memberData.memberId
          )
          .then((result) => {
            if (result.data.status === false) {
            // this.$swal(
            //   'ไม่พบบัญชีผู้ใช้',
            //   'กรุณาตรวจสอบหมายเลขโทรศัพท์',
            //   'error'
            // )
            // this.confirmBtn = true
            } else {
              this.specailPoint = result.data
              console.log('test3', result.data)
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    async getPointActivity () {
      try {
        await axios
          .get(
            this.DNS_IP +
              '/activityLog/get?shopId=' +
              this.$session.getAll().data.shopId +
              '&memberId=' +
              this.memberData.memberId
          )
          .then((result) => {
            if (result.data.status === false) {
            // this.$swal(
            //   'ไม่พบบัญชีผู้ใช้',
            //   'กรุณาตรวจสอบหมายเลขโทรศัพท์',
            //   'error'
            // )
            // this.confirmBtn = true
            } else {
              this.activiPoint = result.data
              // console.log('test3', result.data)
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    changeTag (item) {
      this.tagSelect = item
    },
    async addPoint () {
      console.log('addPoint')
      this.dialogAddpoint = true
    },
    async callApiAddpoint () {
      try {
        let a = this.ProductExchangeRate.filter(
          (el) => el.value === this.formAdd.productExchangeRateId
        )
        let newPoint = Math.floor(this.formAdd.amount / a[0].exchangeRate)
        this.$swal({
          title: 'ต้องการเพิ่มคะแนน?',
          html: 'คุณ' + this.memberData.name + '<br>เพิ่มคะแนน ' + newPoint + ' คะแนน',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#1b437c',
          cancelButtonColor: '#da484f',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          closeOnConfirm: false
        }).then((response) => {
          this.loading = true
          let data = {
            shopId: this.$session.getAll().data.shopId,
            tel: this.memberData.tel.split('-').join('').trim(),
            Amount: this.formAdd.amount,
            exchangRateId: this.formAdd.productExchangeRateId.toString(),
            masBranchID: this.formAdd.masBranchID,
            branchName: this.dataBranch.filter(item => item.value === this.formAdd.masBranchID)[0].text,
            employee: this.$session.getAll().data.userName
          }
          console.log('data', data)
          axios.post(this.DNS_IP + '/POSapi', data).then((response) => {
            console.log('POSapi"', response.data.status)
            if (response) {
              this.$swal('เรียบร้อย', 'เพิ่มเหรียญเรียบร้อย', 'success')
              this.loading = false
              this.dialogAddpoint = false
              this.clearData()
            }
          })
        })
      } catch (error) {
        console.log('error', error)
      }
    },
    clearData () {
      try {
        console.log('this.memberData', this.memberData)
        this.memberData = null
        this.text = null
      } catch (error) {
        // console.log('error', error)
      }
      // this.text = null
      // console.log('this.memberData', this.memberData)
    },
    async getProductExchangeRate () {
      this.ProductExchangeRate = []
      await axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            s.userId = d.userId
            s.allData = d
            console.log(d)
            this.ProductExchangeRate.push(s)
          }
          if (this.ProductExchangeRate.length === 1) {
            this.formAdd.productExchangeRateId =
              this.ProductExchangeRate[0].value
            this.formAdd.name = this.ProductExchangeRate[0].text
          } else {
            var a = this.ProductExchangeRate.filter((el) => {
              if (
                el.value === this.$session.getAll().data.productExchangeRateId
              ) {
                return el
              }
            })
            console.log('a', a.value)
            if (a.length > 0) {
              this.formAdd.productExchangeRateId = a[0].value
              this.formAdd.name = a[0].text
            }
            // console.log('f')
          }
          console.log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        })
        .catch((error) => {
          console.log(error)
          // this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async getDataBranch () {
      this.dataBranch = []
      await axios
        .get(
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            s.allData = d
            this.dataBranch.push(s)
          }
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = this.dataBranch[0].value
            this.formAdd.branchName = this.dataBranch[0].text
          }
        })
        .catch((error) => {
          console.log(error)
          // this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
      // console.log('dataBranch', this.dataBranch.filter(item => item.value === 379)[0].text)
    },
    clear () {
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = ''
      this.formAdd.tel = ''
      this.formAdd.masBranchID = ''
      this.formAdd.refId = ''
      this.formAdd.point = ''
      this.formAdd.token = ''
      this.formAdd.status = 'waiting'
      this.formAdd.statusMemberCard = 'collect'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.qrCodePoint = null
      this.specailPoint = null
      this.activiPoint = null
      this.allDataTransactionGetpoint = null
    }
  }
}
</script>
<style scoped>
  /* body, html {
  height: auto;
} */
</style>



// WEBPACK FOOTER //
// src/components/Master/DataMemberByBarcode.vue